import React, { useState, useEffect, useCallback } from 'react';
import { DataTable } from '../../components/DataTable/DataTable';
import { useDataTable } from '../../components/DataTable/useDataTable';
import { SatFacturasFaltantesService } from '../../services/SatFacturasFaltantesService';
import moment from 'moment';
import { Button, Icon } from '@material-ui/core';

const FacturasSatFaltantes = () => {
    const tableState = useDataTable({ 
        initialLimit: 15, 
        initialOrderBy: 'fecha_emision', 
        initialOrder: 'desc' 
    });

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        const rows = await SatFacturasFaltantesService.obtenerLista(
            tableState.page,
            tableState.limit,
            tableState.filters,
            tableState.orderBy,
            tableState.order
        );
        setData(rows);
        setLoading(false);
    }, [tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);
    
    const handleDownloadCSV = async () => {
        setLoading(true);
        const allData = await SatFacturasFaltantesService.exportCSV();
        if (allData && allData.length > 0) {
            const headers = columns.map(c => c.label).join(',');
            const rows = allData.map(row => {
                return columns.map(c => {
                    let val = row[c.id];
                    if (c.id === 'fecha_emision') val = moment(val).format('YYYY-MM-DD HH:mm');
                    if (val === null || val === undefined) val = '';
                    return `"${val.toString().replace(/"/g, '""')}"`;
                }).join(',');
            }).join('\n');
            
            const csvContent = "\uFEFF" + headers + "\n" + rows;
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", `Facturas_SAT_Faltantes_${moment().format('YYYY-MM-DD')}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const hasMore = data.length === tableState.limit;

    const columns = [
        { id: 'uuid', label: 'UUID / Folio Fiscal', filter: true },
        { id: 'rfc_emisor', label: 'RFC Emisor', filter: true },
        { id: 'nombre_emisor', label: 'Emisor', filter: true },
        { id: 'rfc_receptor', label: 'RFC Receptor', filter: true },
        { id: 'nombre_receptor', label: 'Receptor', filter: true },
        {
            id: 'fecha_emision',
            label: 'Fecha Emisión',
            filter: true,
            render: (row) => moment(row.fecha_emision).format('DD/MM/YYYY HH:mm')
        },
        {
            id: 'total',
            label: 'Total',
            filter: true,
            render: (row) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(row.total)
        },
        { id: 'estatus', label: 'Estatus', filter: true },
    ];

    return (
        <div className="w-full p-4 md:p-6">
            <div className="mb-4 flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Facturas SAT Faltantes</h1>
                    <p className="text-gray-600">Facturas registradas en el SAT que no se encuentran en SOLEXX.</p>
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Icon>download</Icon>}
                    onClick={handleDownloadCSV}
                    disabled={loading}
                >
                    Descargar CSV
                </Button>
            </div>
            <DataTable
                columns={columns}
                data={data}
                loading={loading}
                hasMore={hasMore}
                page={tableState.page}
                limit={tableState.limit}
                onPageChange={tableState.handlePageChange}
                onLimitChange={tableState.handleLimitChange}
                orderBy={tableState.orderBy}
                order={tableState.order}
                onSort={tableState.handleSort}
                filters={tableState.filters}
                onFilterChange={tableState.handleFilterChange}
            />
        </div>
    );
};

export default FacturasSatFaltantes;
